export enum InflightActionType {
  ALERT,
  CANCEL,
  PAUSE,
}

export namespace InflightActionType {
  let elements = [InflightActionType.ALERT, InflightActionType.CANCEL, InflightActionType.PAUSE];
  let alias = "com.bcdfx.model.InflightActionType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
